import {Action, ActionReducer, createReducer, createSelector, on} from '@ngrx/store';
import * as exportActions from './export.actions';

export const exportFeatureKey = 'export';

export interface ExportState {
  template: any;
  metaData: object;
}

const initialState: ExportState = {
  template: undefined,
  metaData: {},
};

export const exportReducer = createReducer(
  initialState,
  on(exportActions.updateTemplate, (state, action) => ({...state, template: action.template})),
  on(exportActions.updateMetadata, (state, action) => ({...state, metaData: action.metaData})),
);

export const selectExportState = (state): ExportState => state.export;

/**
 * Selects the template
 */
export const selectTemplate = createSelector(
  selectExportState,
  (state: ExportState) => state.template,
);

/**
 * Selects the meta data
 */
export const selectMetadata = createSelector(
  selectExportState,
  (state: ExportState) => state.metaData,
);

export const exportMetadataReducer: ActionReducer<ExportState, any> = (
  state: ExportState | undefined,
  action: Action,
) => {
  return exportReducer(state, action);
};
